<template>
  <div id="app">
    <Sidebar />

    <main>
      <Header :route="$route.fullPath"/>
      <router-view :key="$route.fullPath" class="main-content"/>
    </main>

    <Footer />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import Footer from './components/layout/Footer.vue'
import Header from './components/layout/Header.vue'
import Sidebar from './components/layout/Sidebar.vue'

@Component({
  name: 'App',
  components: { Header, Footer, Sidebar }
})
class App extends Vue {
  insertOpenSearch() {
    let linkId = 'opensearch'
    // on retire l'ancien quoi qu'il arrive
    let old = document.getElementById(linkId)
    old && old.remove()

    let token = this.$storage.getCookie('bow-token')
    if (token) {
      // <link title="bow" type="application/opensearchdescription+xml" rel="search" href="<%= VUE_APP_BOW_PUBLIC_API_URL %>/api/v1/opensearch">
      let link = document.createElement('link')
      link.id = linkId
      link.title = 'bow'
      link.type = 'application/opensearchdescription+xml'
      link.rel = 'search'
      link.href = `${location.protocol}//${location.hostname}/api/v1/opensearch?bow-token=${token}`
      document.head.appendChild(link)
    }
  }

  reload() {
    let user = this.$storage.get('bow-user') || {}
    this.$store.commit('user', user)
    this.$store.commit('authenticated', !!this.$storage.getCookie('bow-token'))
    this.insertOpenSearch()
    if (user.lang && user.lang != this.$i18n.locale()) {
      console.log('loading lang...', user.lang)
      this.$fetch.i18n(user.lang).then(
        data => {
          console.log('lang loaded', user.lang)
          this.$i18n.add(user.lang, data)
          this.$i18n.set(user.lang)
        },
        err => {
          this.errorMsg = err.cause
        }
      )
    }
  }

  beforeMount() {
    console.log('beforeMounted App')
    this.reload()
    this.$storage.addListener('bow-user', this.reload, this)
  }
}
export default App
</script>

<style lang="less">
@import './assets/less/main';
@import './assets/less/globals';

#app {
  color: var(--color-text);
  font-family: var(--font);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  background-color: var(--color-bg);
}

main {
  min-height: 100vh;

  padding-bottom: var(--footer-height);
}

@media screen and (min-width: @screen-desktop-low) {
  body {
    padding-left: var(--sidebar-width);
  }

  main {
    display: flex;
    flex-direction: column;
  }

  .main-content {
    flex-grow: 1;
  }
}
</style>
